import {motion} from "framer-motion";

const EventsAnimation = ({children}) => {
    return <motion.div
        initial={{opacity: 0, y: 100}}
        animate={{opacity: 1, y: 0}}
        transition={{duration: 0.5}}
    >
        {children}
    </motion.div>
}

export {EventsAnimation}